/* =========================================================
   Thoson reviews marquee: motion and touch.
   Loaded by sections/thx-reviews-marquee.liquid.

   Without this file the rows still slide with the CSS animation
   in thx-reviews-marquee.css. With it, each row is moved from
   here, so a finger can take hold of it:
   - drag sideways to scroll the reviews; let go and the row
     glides, rests a moment and picks up its speed again;
   - a tap stops the row for a moment so a review can be read;
   - a vertical swipe still scrolls the page (touch-action: pan-y);
   - with a mouse, the row eases to a stop under the pointer so
     its product link can be clicked, and speeds up on leaving.
   Only the copies of the reviews that the screen needs stay in
   the page, which keeps the moving layer small on phones.
   Reduced motion: phones and tablets move even when the device
   asks for reduced motion (Fares, 27 sep). Only a computer with
   a mouse, 750px wide or more, that asks for it gets nothing
   from here: the CSS leaves a still strip it can scroll.
   ========================================================= */
(function () {
  'use strict';
  if (window.thxReviewsMarquee) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce) and (hover: hover) and (min-width: 750px)');
  var rows = [];
  var raf = 0;
  var last = 0;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var r = find(en.target);
      if (r) r.visible = en.isIntersecting;
    });
    kick();
  }, { rootMargin: '100px 0px' }) : null;
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) {
      var r = find(en.target.closest('.thx-rvm__row'));
      if (r) r.measure();
    });
  }) : null;

  function find(el) {
    for (var i = 0; i < rows.length; i++) if (rows[i].el === el) return rows[i];
    return null;
  }

  // Position inside (-p, 0]: the row repeats itself every p pixels.
  function wrap(x, p) {
    if (!(p > 0)) return 0;
    x = x % p;
    if (x > 0) x -= p;
    return x;
  }

  function Row(el) {
    var self = this;
    this.el = el;
    this.track = el.querySelector('.thx-rvm__track');
    this.sets = Array.prototype.slice.call(this.track.children);
    this.dir = this.track.classList.contains('thx-rvm__track--r') ? 1 : -1;
    this.pxs = parseFloat(this.track.getAttribute('data-pxs')) || 34;
    this.p = 0;
    this.v = 0;          // glide speed after a swipe, px/s
    this.s = 1;          // share of the cruising speed, eased 0..1
    this.until = 0;      // stay still until this time
    this.drag = null;
    this.hover = false;
    this.focus = false;
    this.visible = true;
    this.movedAt = -1e9;
    this.off = [];

    // Start where the CSS animation is now, so nothing jumps.
    var t = getComputedStyle(this.track).transform;
    var x = 0;
    if (t && t.indexOf('matrix') === 0) {
      var n = t.slice(t.indexOf('(') + 1, t.lastIndexOf(')')).split(',');
      x = parseFloat(t.indexOf('matrix3d') === 0 ? n[12] : n[4]) || 0;
    }
    this.x = x;

    this.listen(el, 'pointerdown', function (e) { self.down(e); });
    this.listen(el, 'pointermove', function (e) { self.move(e); });
    this.listen(el, 'pointerup', function (e) { self.up(e, false); });
    this.listen(el, 'pointercancel', function (e) { self.up(e, true); });
    // Only the row's own capture counts: taking it over from the pill fires this too.
    this.listen(el, 'lostpointercapture', function (e) { if (e.target === el && self.drag && e.pointerId === self.drag.id) self.up(e, false); });
    this.listen(el, 'pointerenter', function (e) { if (e.pointerType === 'mouse') { self.hover = true; kick(); } });
    this.listen(el, 'pointerleave', function (e) { if (e.pointerType === 'mouse') { self.hover = false; kick(); } });
    this.listen(el, 'focusin', function () { self.focus = true; });
    this.listen(el, 'focusout', function () { self.focus = false; });
    this.listen(el, 'dragstart', function (e) { e.preventDefault(); });
    // A drag that ends on a product link must not open it.
    this.listen(el, 'click', function (e) {
      if (performance.now() - self.movedAt < 400) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  Row.prototype.listen = function (target, type, fn, capture) {
    target.addEventListener(type, fn, capture || false);
    this.off.push([target, type, fn, capture || false]);
  };

  Row.prototype.measure = function () {
    var i;
    for (i = 0; i < this.sets.length; i++) this.sets[i].style.display = '';
    var p = this.sets[0] ? this.sets[0].getBoundingClientRect().width : 0;
    this.p = p > 0 ? p : 0;
    if (!this.p) return;
    // Wherever the row sits inside one copy, the copies shown must still cover the screen.
    var need = Math.min(this.sets.length, Math.ceil(this.el.clientWidth / this.p) + 1);
    for (i = need; i < this.sets.length; i++) this.sets[i].style.display = 'none';
    this.x = wrap(this.x, this.p);
    this.paint();
  };

  Row.prototype.paint = function () {
    this.track.style.transform = 'translate3d(' + this.x.toFixed(2) + 'px,0,0)';
  };

  Row.prototype.step = function (dt, now) {
    if (!this.p || this.drag) return;
    if (Math.abs(this.v) > 8) {
      this.x += this.v * dt;
      this.v *= Math.exp(-dt / 0.325);
      this.s = 0;
    } else {
      if (this.v !== 0) {
        this.v = 0;
        this.until = Math.max(this.until, now + 900);
      }
      var want = this.hover || this.focus || now < this.until ? 0 : 1;
      this.s += (want - this.s) * Math.min(1, dt * 3.5);
      if (want === 0 && this.s < 0.002) this.s = 0;
      if (!this.s) return;
      this.x += this.dir * this.pxs * this.s * dt;
    }
    this.x = wrap(this.x, this.p);
    this.paint();
  };

  Row.prototype.down = function (e) {
    if (e.pointerType === 'mouse' || !e.isPrimary) return;
    var now = performance.now();
    this.drag = { id: e.pointerId, x0: e.clientX, from: this.x, lx: e.clientX, lt: now, vx: 0, on: false };
    this.v = 0;
  };

  Row.prototype.move = function (e) {
    var d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    var dx = e.clientX - d.x0;
    if (!d.on) {
      if (Math.abs(dx) < 6) return;
      d.on = true;
      d.x0 = e.clientX;
      d.from = this.x;
      dx = 0;
      try { this.el.setPointerCapture(d.id); } catch (err) { /* not capturable: keep going */ }
      this.el.classList.add('is-dragging');
    }
    var now = performance.now();
    var dt = (now - d.lt) / 1000;
    if (dt > 0) {
      d.vx = 0.8 * ((e.clientX - d.lx) / dt) + 0.2 * d.vx;
      d.lx = e.clientX;
      d.lt = now;
    }
    this.x = wrap(d.from + dx, this.p);
    this.paint();
  };

  Row.prototype.up = function (e, cancelled) {
    var d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    this.drag = null;
    this.el.classList.remove('is-dragging');
    var now = performance.now();
    if (d.on) {
      var still = cancelled || now - d.lt > 90;
      this.v = still ? 0 : Math.max(-2400, Math.min(2400, d.vx));
      this.s = 0;
      this.movedAt = now;
      this.until = now + 900;
    } else if (!cancelled) {
      this.until = now + 2500;
    }
    kick();
  };

  Row.prototype.destroy = function () {
    if (io) io.unobserve(this.el);
    if (ro) { ro.unobserve(this.el); if (this.sets[0]) ro.unobserve(this.sets[0]); }
    this.off.forEach(function (o) { o[0].removeEventListener(o[1], o[2], o[3]); });
    this.off = [];
    this.track.style.transform = '';
    this.sets.forEach(function (s) { s.style.display = ''; });
    this.el.classList.remove('is-dragging');
  };

  function tick(now) {
    raf = 0;
    var dt = Math.min(0.05, Math.max(0, (now - last) / 1000));
    last = now;
    var any = false;
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].visible) continue;
      rows[i].step(dt, now);
      any = true;
    }
    if (any) raf = requestAnimationFrame(tick);
  }

  function kick() {
    if (raf || !rows.length) return;
    last = performance.now();
    raf = requestAnimationFrame(tick);
  }

  function init(root) {
    if (reduce.matches) return;
    var secs = (root || document).querySelectorAll('.thx-rvm');
    Array.prototype.forEach.call(secs, function (sec) {
      if (sec.classList.contains('thx-rvm--js')) return;
      var els = sec.querySelectorAll('.thx-rvm__row');
      if (!els.length) return;
      var made = [];
      Array.prototype.forEach.call(els, function (el) {
        if (el.querySelector('.thx-rvm__track')) made.push(new Row(el));
      });
      sec.classList.add('thx-rvm--js');
      made.forEach(function (r) {
        rows.push(r);
        r.measure();
        if (io) io.observe(r.el);
        if (ro) { ro.observe(r.el); if (r.sets[0]) ro.observe(r.sets[0]); }
      });
    });
    kick();
  }

  function destroy(root) {
    rows = rows.filter(function (r) {
      if (root && !root.contains(r.el)) return true;
      r.destroy();
      var sec = r.el.closest('.thx-rvm');
      if (sec) sec.classList.remove('thx-rvm--js');
      return false;
    });
  }

  if (!ro) {
    var timer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { rows.forEach(function (r) { r.measure(); }); }, 150);
    });
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { rows.forEach(function (r) { r.measure(); }); });
  }
  function onReduce() { if (reduce.matches) destroy(null); else init(document); }
  if (reduce.addEventListener) reduce.addEventListener('change', onReduce);
  else if (reduce.addListener) reduce.addListener(onReduce);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });

  window.thxReviewsMarquee = { init: init, destroy: destroy };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();